<template>
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search"
    :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="关键字" name='keyword'>
      <a-input v-model:value="search.keyword" :style="{width:'300px'}" placeholder="请输入关键词进行搜索" />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered  :columns='columns' :data-source='data'>
    <template v-slot:info="{record}">
      <a-card-meta>
        <template #avatar>
          <img :src="info.picdomain+'/'+(record.product_image||record.cover_image_url)" alt=""
            style="width:50px;height: 50px;object-fit:cover">
        </template>
        <template #description>{{record.product_name}}</template>
      </a-card-meta>
    </template>
    <template v-slot:category="{ record }">
      <p>{{record.product_cate || '未分类'}}</p>
    </template>
    <template v-slot:action="{ record }">
      <a-button type="primary" @click='select(record)' :ghost="!record.select" v-if='!checkout'>{{!record.select ?
        "选择":"已选择"}}</a-button>
      <a-button type="primary" @click='checkBnt(record)' :ghost="!record.select" v-else>{{!record.select ? "选择":"已选择"}}
      </a-button>
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page"
    :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
  <div class="s_flex_center m-t-25" v-if='checkout'>
    <a-button type="primary" @click='confirm'>确定</a-button>
  </div>
</template>

<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getWarehousingGoods } from "@/api/antiFleeing";
  import { iscode } from "@/utils/app";
  import store from "@/store";
  // 初始化默认筛选项数值
  let defSearch = {
    keyword:'',
    page: 1,
    limit: 5,
    status: 1
  };
  export default {
    name: "warehousingGoods",
    components: {},
    props: {
      selectList: {
        type: Array
      },
      checkout: {
        type: Boolean
      },
    },
    setup(props, { emit }) {
      // // 初始化 分页信息和筛选项信息
      let search = ref({ ...defSearch });
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        info: store.state.user.info,
        listLoading: false,
        total: 0,
        selectList: [],
        checkout: false,
        columns: [
          {
            title: "ID",
            dataIndex: "product_id",
            key: "product_id",
          },

          {
            title: "商品信息",
            dataIndex: "info",
            key: "info",
            slots: { customRender: "info" },
          },
          {
            title: "规格",
            dataIndex: "product_sku_name",
            key: "product_sku_name",
            customRender:({record})=>{
              return record.product_sku_name ? record.product_sku_name:'单规格'
            } 
          },
          {
            title: "产品库分类",
            dataIndex: "category",
            key: "category",
            slots: { customRender: "category" },
          },
          {
            title: "价格/元",
            dataIndex: "product_price",
            key: "product_price",
          },
          {
            title: "操作",
            key: "action",
            width: 120,
            slots: { customRender: "action" },
          },
        ]
      });
      const $router = inject('$router')
      const $Modal = inject('$Modal')
      const _lodash = inject("_lodash");

      // 页面筛选项搜索
      const pageSearchChange = () => {
         search.value.page=1
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      //单选
      const select = (e) => {
        if(e.select){
          return
        }
        data.value.map(item => item.select = false)
        e.select = !e.select
        emit("select", e);
      }
      //多选
      const checkBnt = (e) => {
        if(props.selectLimit && state.selectList.length == 5 && !e.select){
          message.error('最多只能选择'+props.selectLimit+'个商品');
          return
        }
        if(!e.select){
          if(e.spec_type == 1){
            e.key = e.product_id+'_'+e.product_sn
          }else{
            e.key = e.product_id+'_'+e.product_sku_sn
          }
          state.selectList.push(e)
        }else{
          // state.selectList
          var key=-1
          state.selectList.forEach((v,k)=>{
            if(v.product_id==e.product_id){
              key=k
            }
          })
          if(key!=-1){
            state.selectList.splice(key,1)
          }
        }
        e.select = !e.select
      }
      //多选确认
      const confirm = () => {
        emit("select", state.selectList);
      }
      const initData = async (values) => {
        state.listLoading = true;
        try {
          let res = await getWarehousingGoods(values).then(res => res.data);
           data.value=[]
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data;
            console.log(data.value)
            state.total =  res.meta.total;
            if (state.selectList.length > 0) {
              data.value.forEach(i => {
                if(i.spec_type == 1){
                  if (state.selectList.find(v => (i.product_id+'_'+i.product_sn) == v.key)) {
                    i.select = true
                  }else{
                    i.select = false
                  }
                }else{
                  if (state.selectList.find(v => (i.product_id+'_'+i.product_sku_sn) == v.key)) {
                    i.select = true
                  }else{
                    i.select = false
                  }
                }
              })
            }
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        if(props.selectList){
          state.selectList = JSON.parse(JSON.stringify(props.selectList))
          state.selectList.map(v=> {
            if(v.spec_type == 1){
              v.key = v.product_id+'_'+v.product_sn
            }else{
              v.key = v.product_id+'_'+v.product_sku_sn
            }
          })
        }
        initData(search.value);
      });
      return {
        ...toRefs(state),
        search,
        data,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        select,
        checkBnt,
        confirm
      };
    },
  };
</script>